import React, { useEffect, useState } from 'react';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const StyledGrid = styled(Grid)`
    .alert {
        background: ${(props) => props.theme.colors.base.red};
    }
    .MuiSnackbar-anchorOriginBottomCenter {
        bottom:90% !important;
    }
`;

export interface IProps {
    showAlertMessage: string;
    alertType: string;
}

const Alert = (props: IProps) => {
    const [alertMessage, setAlertMessage] = useState('');
    const [openToast, setOpenToast] = useState(false);
    const { showAlertMessage, alertType } = props;

    useEffect(() => {
        setOpenToast(true);
        setAlertMessage(showAlertMessage);
    }, []);

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenToast(false);
    };

    return (
        <StyledGrid>
            <Snackbar open={openToast} autoHideDuration={3000} onClose={handleClose}>
                {alertType === 'error' ?
                    <Alert onClose={handleClose} className="alert">
                        {alertMessage}
                    </Alert> :
                    <Alert onClose={handleClose} severity="success">
                        {alertMessage}
                    </Alert>
                }
            </Snackbar>
        </StyledGrid>
    )
}

export default Alert;